/**
 * Matching for the pickers, kept out of the component so it can be tested.
 *
 * The behaviour it exists for is the one a native `<select>` cannot do: its
 * type-ahead matches only from the first character of an option's text, so
 * "york" finds nothing in `America/New_York` and neither does "new york" --
 * the separator stops it. Both find it here.
 */

/**
 * Lowercased, with the separators people do not type flattened to spaces.
 *
 * `America/New_York` and `Asia/Ho_Chi_Minh` are how IANA writes them and not
 * how anybody searches for them.
 */
export function normaliseForSearch(text: string): string {
  return text
    .toLowerCase()
    .replace(/[_/\-—]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Every word of the query, present anywhere in the haystack, in any order.
 *
 * Word-wise rather than as one substring, so "jakarta asia" finds the same row
 * as "asia jakarta" -- somebody who half-remembers a zone should not have to
 * remember the order it is written in. An empty query matches everything, which
 * is what makes a freshly-opened list show the whole set.
 */
export function matchesQuery(haystack: string, query: string): boolean {
  const words = normaliseForSearch(query).split(" ").filter(Boolean);
  if (words.length === 0) return true;
  const target = normaliseForSearch(haystack);
  return words.every((word) => target.includes(word));
}
